import { render, staticRenderFns } from "./Canvas.vue?vue&type=template&id=0940ca6c&scoped=true"
import script from "./Canvas.vue?vue&type=script&lang=ts"
export * from "./Canvas.vue?vue&type=script&lang=ts"
import style0 from "./Canvas.vue?vue&type=style&index=0&id=0940ca6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0940ca6c",
  null
  
)

export default component.exports